import React from 'react';
import { VerifyAccountForm, ButtonLink } from '@emyw/auth-lib'; // import { log } from '@emyw/core-lib';

import { Header, Divider, Image } from 'semantic-ui-react';
import '../custom-theme.css';
var REACT_APP_ACCOUNT_API_IMAGE_PATH = process.env.REACT_APP_ACCOUNT_API_IMAGE_PATH;

var Step2VerifyResult = function Step2VerifyResult(props) {
  if (props.skipVerification) {
    return /*#__PURE__*/React.createElement(VerifyAccountForm, Object.assign({}, props, !props.onLogin ? {
      onLogin: function onLogin() {
        return null;
      }
    } : undefined, {
      skipVerification: true,
      autoAuthenticate: true
    }));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "wizardStepBase verifyResult"
  }, /*#__PURE__*/React.createElement(Header, {
    color: "grey",
    as: "h2",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Image, {
    size: "huge",
    src: "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/circle-email.png")
  }), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "stepTitleChangeable"
  }, "Check your email!", props.verificationEmail
  /* && !props.location.search */
  &&
  /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: "header light"
  }, props.verificationEmail), /*#__PURE__*/React.createElement(Header.Subheader, {
    className: "stepChange"
  }, /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: props.onChangeEmail
  }, "Change email")))), props.verificationEmail
  /* && !props.location.search */
  ?
  /*#__PURE__*/
  React.createElement(Header.Subheader, null, /*#__PURE__*/React.createElement("br", null), "Okay, a little annoying, we know. But to stop bots and spammers,", /*#__PURE__*/React.createElement("br", null), "we need to verify your email. It should arrive any second!") : /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Header.Subheader, null, /*#__PURE__*/React.createElement("br", null), "Enter in the code from your email to reveal the last step.")), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "subscribeStepContent"
  }, /*#__PURE__*/React.createElement(VerifyAccountForm, Object.assign({}, props, !props.onLogin ? {
    onLogin: function onLogin() {
      return null;
    }
  } : undefined, {
    codeEntryMode: true,
    autoAuthenticate: true
  }))));
};

Step2VerifyResult.defaultProps = {
  verificationEmail: undefined
};
export default Step2VerifyResult;